import API from '.';

export default class Site {
  /**
   * The Timezone dimension table for UDM
   * @param {int} siteId The database ID for the Site
   * @param {String} siteCode The shorthand code for the Site
   * @param {Array} country The ID for the Country of the Site
   * @param {String} siteName The full name of the Site
   * @param {int} operationStatusId ID relating to the operation Status
   * @param {int} primaryUseTypeId ID relating to the operation Status
   * @param {Array} itSiteCodeRelate Relations to specific IT Site Codes for the Site
   * @param {Array} siteSourceSystemRelate Relations to other systems to identify Sites
   * @param {Array} destinationSystem Integration destinations for creating/updating Sites
   */
  constructor({
    siteId,
    country,
    siteCode,
    siteName,
    operationStatusId,
    primaryUseTypeId,
    itSiteCodeRelate,
    siteSourceSystemRelate,
    destinationSystem
  }) {
    this.siteId = siteId;
    this.country = country;
    this.siteCode = siteCode;
    this.siteName = siteName;
    this.operationStatusId = operationStatusId;
    this.primaryUseTypeId = primaryUseTypeId;
    this.itSiteCodeRelate = itSiteCodeRelate;
    this.siteSourceSystemRelate = siteSourceSystemRelate;
    this.destinationSystem = destinationSystem;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/site');
    return data.map((d) => new Site(d));
  }

  static async get(id) {
    const api = await API();
    const { data } = await api.get(`site/${id}`);
    return new Site(data);
  }

  static async update(data) {
    const api = await API();
    return await api.put(`/site`, data);
  }

  static validateSourceSystemReferenceId(
    sourceSystemIdTypeId,
    sourceSystemReferenceId
  ) {
    const api = API();
    return new Promise((resolve) => {
      resolve(
        api.get(
          'SiteSourceSystemRelate/ValidateSourceSystemReferenceId',
          {
            params: {
              sourceSystemIdTypeId: sourceSystemIdTypeId,
              sourceSystemReferenceId: sourceSystemReferenceId
            },
          }
        )
      );
    });
  }
}
